import api from '@/services/api';

const getDefaultState = () => {
  return {
    numeroCarte: '',
    point: null,
  };
};

const state = getDefaultState();

const getters = {
  getNumeroCarte(state) {
    return state.numeroCarte;
  },
  getPoint(state) {
    return state.point;
  },
};

const actions = {
  async verifierStatutAppariement({ state, commit }) {
    return new Promise((resolve, reject) => {
      api
        .call('casino-privileges/pairing-status', 'cpVerifierStatutAppariement')
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  async obtenirCarte({ state, commit }) {
    return new Promise((resolve, reject) => {
      api
        .call('casino-privileges/card', 'cpObtenirCarte')
        .then((response) => {
          if (response.data) {
            if (response.data.number) {
              commit('SET_NUMERO_CARTE', response.data.number);
              commit('SET_POINT', response.data.point);
            }
          }

          if (response.data && response.data.status === 'SUCCESS') {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  async sauvegarderCarte({ commit }, numeroCarte) {
    return new Promise((resolve, reject) => {
      api
        .call('casino-privileges/card', 'cpSauvegarderCarte', 'put', {
          data: {
            number: numeroCarte,
          },
        })
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            commit('SET_NUMERO_CARTE', response.data.number);
            commit('SET_POINT', response.data.point);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

const mutations = {
  RESET(state) {
    Object.assign(state, getDefaultState());
  },
  SET_NUMERO_CARTE(state, value) {
    state.numeroCarte = value;
  },
  SET_POINT(state, value) {
    state.point = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
